"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAdminProfileUpdateTransport = exports.HaulerAdminProfileCreateTransport = exports.AppAdminProfileUpdateTransport = exports.AppAdminProfileCreateTransport = exports.ProfileUserCreateTransport = exports.ProfileTransport = exports.LoginIdentifier = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const announcement_transport_1 = require("./announcement-transport");
const last_release_notes_transport_1 = require("./last-release-notes-transport");
/** An identifier a user can sign in with. */
exports.LoginIdentifier = typebox_1.Type.Union([typebox_1.Type.Literal('EMAIL'), typebox_1.Type.Literal('PHONE')]);
exports.ProfileTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    fullName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    slackId: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    notificationPreferences: typebox_1.Type.Object({
        textOk: typebox_1.Type.Boolean(),
        emailOk: typebox_1.Type.Boolean(),
    }),
    authorities: typebox_1.Type.Array(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        active: typebox_1.Type.Boolean(),
        haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        contactID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        haulerName: typebox_1.Type.Optional(typebox_1.Type.String()),
        applicationName: typebox_1.Type.String(),
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    })),
    /** True when the profile has a password-based Auth0 identity, i.e. it signs in through auth v2. */
    isAuthV2Enabled: typebox_1.Type.Boolean(),
    unseenAnnouncements: typebox_1.Type.Optional(typebox_1.Type.Array(announcement_transport_1.AnnouncementTransport)),
    lastReleaseNotes: typebox_1.Type.Optional((0, nullable_1.Nullable)(last_release_notes_transport_1.LastReleaseNotesTransport)),
    lastLogin: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    /** S3 key of the profile photo. Resolved to a signed URL by whoever displays it. */
    photoS3Key: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    metadata: common_1.MetaData,
});
exports.ProfileUserCreateTransport = typebox_1.Type.Object({
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    email: typebox_1.Type.String({ format: 'email' }),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    slackId: typebox_1.Type.Optional(typebox_1.Type.String()),
    roles: typebox_1.Type.Array(typebox_1.Type.String()),
    customer: typebox_1.Type.Optional(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        contactID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    })),
});
exports.AppAdminProfileCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.ProfileTransport, ['email', 'firstName', 'lastName', 'phoneNumber', 'active', 'slackId', 'photoS3Key']),
    typebox_1.Type.Object({
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
]);
exports.AppAdminProfileUpdateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(exports.AppAdminProfileCreateTransport),
    typebox_1.Type.Object({
        /** `roles` only ever grants. Revoking is explicit, so an untouched role is never lost to an omission. */
        removeRoles: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    }),
]);
exports.HaulerAdminProfileCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        email: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'email' })),
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
    typebox_1.Type.Pick(exports.ProfileTransport, ['firstName', 'lastName', 'phoneNumber']),
]);
exports.HaulerAdminProfileUpdateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        addRoles: typebox_1.Type.Array(typebox_1.Type.String()),
        removeRoles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
    typebox_1.Type.Partial(typebox_1.Type.Pick(exports.ProfileTransport, ['email', 'firstName', 'lastName', 'phoneNumber', 'active'])),
]);
//# sourceMappingURL=profile-transport.js.map